<template>
  <div id="contenedor-subtiposobras-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'SubTiposObrasMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
